module.exports = __webpack_public_path__ + "img/office-cards-ru.f1439ddb.jpg";